/*
 * Copyright (c) CIRROM 2025.
 */

import React from "react";
import styled from "@emotion/styled";

import { Typography } from "@mui/material";
import { MiraTheme } from "../../theme/theme";
import { SidebarItemsType } from "../../types/sidebar";
import SidebarNavList from "./SidebarNavList";

const Title = styled(Typography)<{ theme?: MiraTheme }>`
  color: ${(props) => props.theme?.sidebar?.color};
  font-size: ${(props) => props.theme?.typography?.caption?.fontSize};
  padding: ${(props) => props.theme?.spacing?.(4)}
    ${(props) => props.theme?.spacing?.(7)}
    ${(props) => props.theme?.spacing?.(1)};
  opacity: 0.4;
  text-transform: uppercase;
  display: block;
`;

type SidebarNavSectionProps = {
  className?: Element;
  component?: React.ElementType;
  pages: SidebarItemsType[];
  title?: string;
  isCollapsed?: boolean;
};

export const SidebarNavSection: React.FC<SidebarNavSectionProps> = (props) => {
  const {
    title,
    pages,
    component: Component = "nav",
    isCollapsed = false,
    ...rest
  } = props;

  return (
    <Component {...rest}>
      {title && !isCollapsed && <Title variant="subtitle2">{title}</Title>}
      <SidebarNavList pages={pages} depth={0} isCollapsed={isCollapsed} />
    </Component>
  );
};
